// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607291634/js/" + chunkId + "." + {"44":"aa968d41","225":"261c406c","481":"bddd2ba1","486":"490d68cf","770":"48c4dab1"}[chunkId] + ".0.5859430598802943.chunk.js";
};